<template>
  <div class="px-6 py-2.5 text-[16px] leading-5 font-medium">
    <template v-if="page === 'actions'">
      <p class="text-gray-800">What would you like to do?</p>
    </template>
    <template v-else>
      <p class="text-gray-800">Infringement tools.</p>
      <p class="flex items-center text-gray-400">
        Powered by&nbsp;<DacrAIIcon
          class="h-3.5 w-auto"
          aria-label="Dacr AI"
        />.
      </p>
    </template>
  </div>

  <template v-if="page === 'actions'">
    <UploadMenuRow
      :icon="FileAddIcon"
      label="Copyright registration"
      :disabled="!canRegister"
      @select="emit('register')"
    />
    <UploadMenuRow
      :icon="FileIssueIcon"
      label="Infringement tools"
      description="Quick checks and forensic reports."
      @select="emit('page', 'infringement')"
    />
  </template>
  <template v-else>
    <UploadMenuRow
      :icon="CameraIcon"
      label="Infringement check"
      description="Quick check for potential matches."
      @select="emit('checker')"
    />
    <UploadMenuRow
      :icon="FileIssueIcon"
      label="Infringement report"
      description="Deep analysis. Court-ready report."
      @select="emit('report')"
    />
  </template>
</template>

<script setup lang="ts">
import { CameraIcon, DacrAIIcon, FileAddIcon, FileIssueIcon } from '@dacr/icons'

import UploadMenuRow from './UploadMenuRow.vue'

export type UploadMenuPage = 'actions' | 'infringement'

defineProps<{ page: UploadMenuPage; canRegister: boolean }>()

const emit = defineEmits<{
  page: [page: UploadMenuPage]
  register: []
  checker: []
  report: []
}>()
</script>
